module.exports = __webpack_public_path__ + "img/bg-contacto-1.a591e5a9.png";